import Client from '../HttpClient';

const baseUrl = '/admin/api/menu-group';

const list = () => {
	return Client.get(baseUrl);
};

const find = (Code) => {
	return Client.get(`${baseUrl}/${Code}`);
};

const create = (payload) => {
	return Client.post(baseUrl, payload);
};

const update = (Code, payload) => {
	return Client.put(`${baseUrl}/${Code}`, payload);
};

const remove = (Code) => {
	return Client.del(`${baseUrl}/${Code}`);
};

const options = () => {
	return Client.get(`${baseUrl}/refer`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	options,
};
